// extracted by mini-css-extract-plugin
export default {"simulationNoteContainer":"SimulationNote_simulationNoteContainer__71KLT"};